import { isString } from "lodash";
import { ls } from "./localStorage";

class Authorization {
  constructor() {
    this.authUser = null;
  }

  /**
   * set auth user details to class property
   *
   * @return void
   */
  setAuthUser() {
    this.authUser = JSON.parse(ls.getItem("authorizedUserDetails"));
  }

  /**
   * check is active user is logged in
   *
   * @return boolean
   */
  isLoggedIn() {
    return typeof ls.getItem("authorizedUserDetails") === "string";
  }

  /**
   * get logged in user details
   *
   * @return boolean
   */
  getAuthUser() {
    if (this.isLoggedIn()) {
      this.setAuthUser();
    }

    return this.authUser;
  }

  /**
   * Get authentication access token
   *
   * @return string
   */
  getAccessToken() {
    let accessToken = null;
    const authUser = this.getAuthUser();
    if (authUser && isString(authUser.token)) {
      accessToken = authUser.token;
    }
    return accessToken;
  }
  getProfileId() {
    let profileId = JSON.parse(ls.getItem("authorizedUserDetails"))?.id;
    return profileId;
  }

  /**
   * Get the logged in user's numeric id.
   *
   * Reads the `sub` claim of the access token, which every login flow sets to
   * the profile id, and falls back to the id stored with the login response.
   *
   * @return number|null
   */
  getUserId() {
    const token = this.getAccessToken();
    const payload = token && token.split(".")[1];
    if (payload) {
      try {
        const claims = JSON.parse(
          window.atob(payload.replace(/-/g, "+").replace(/_/g, "/")),
        );
        const tokenUserId = Number(claims.sub);
        if (Number.isSafeInteger(tokenUserId) && tokenUserId > 0) {
          return tokenUserId;
        }
      } catch (error) {
        // Malformed token: fall through to the stored login details.
      }
    }

    const storedId = Number(this.getAuthUser()?.id);
    return Number.isSafeInteger(storedId) && storedId > 0 ? storedId : null;
  }
  /**
   * login the user by setting it in local storage
   *
   * @return boolean
   */
  login(userDetails) {
    if (typeof Storage !== "undefined") {
      ls.removeItem("authorizedUserDetails");
      ls.setItem("authorizedUserDetails", JSON.stringify(userDetails));
    } else {
      console.error("Local storage is not supported");
    }
  }

  /**
   * get logged in user details
   *
   * @return boolean
   */
  logout() {
    if (typeof Storage !== "undefined") {
      ls.removeItem("authorizedUserDetails");
      ls.removeItem("userLandingPath");
      window.location.href = "/";
    } else {
      console.error("Local storage is not supported");
    }
  }

  getUserType() {
    // let userType = "Associate";
    let userType = "User";

    return userType;
  }
}

export default new Authorization();
